import {Footer, Header, StarRating} from "@components";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {api} from "@utils";
import {IReview, IReviewData, ResultPagingResponse} from "@data";
import {Images, Svgs} from "@assets";
import moment from "moment";

export default function Page() {
  const [reviewData, setReviewData] =
    useState<ResultPagingResponse<IReviewData>>();

  async function getReviewData({page = 1}: {page?: number} = {}) {
    try {
      const {success, data} = await api.v1.review.getList({
        page,
      });
      if (success) {
        setReviewData(data);
      }
    } catch (error) {
      console.error("getReviewCount error", error);
    }
  }

  useEffect(() => {
    getReviewData();
  }, []);

  return (
    <div className="page">
      <Header />
      <div className={styles.container}>
        <div className={styles.titleSection}>
          <div className={styles.title}>장례후기</div>
          <div className={styles.desc}>
            실제 의뢰한 고객분들만 작성 가능합니다.
            <br />
            클린한 후기를 확인해보세요.
          </div>
          <div className={styles.boxList}>
            <div className={[styles.box, styles.box1].join(" ")}>
              <div className={styles.left}>
                <div>고객후기 작성수</div>
                <div>
                  <span>{reviewData?.page?.maxcnt || 0}개</span>
                </div>
              </div>
              <div className={styles.right}>
                <Svgs.Chart />
                <div>{reviewData?.page?.maxcnt || 0}건</div>
              </div>
            </div>
            <div className={[styles.box, styles.box2].join(" ")}>
              <div className={styles.left}>
                <div>고객후기 평점</div>
                <div>
                  <span>
                    {Number(reviewData?.result.star?.avg || 0).toFixed(1)}
                  </span>
                  <div>/ 5.0</div>
                </div>
              </div>
              <div className={styles.right}>
                <div className={styles.graphList}>
                  {[1, 2, 3, 4, 5].map(star => {
                    const count =
                      (reviewData?.result.star?.count || []).find(
                        item => item.star === star,
                      )?.cnt || 0;
                    const percent =
                      (reviewData?.page?.maxcnt || 0) > 0
                        ? Number(
                            ((count || 0) / (reviewData?.page?.maxcnt || 0)) *
                              100,
                          )
                        : 0;
                    return (
                      <div className={styles.graphItem} key={star}>
                        <div>{percent.toLocaleString()}%</div>
                        <div>
                          <div className={styles.graphBg}></div>
                          <div
                            className={styles.graphActive}
                            style={{height: (127 * percent) / 100}}></div>
                        </div>
                        <div>{star}점</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.list}>
          {(reviewData?.result?.list || []).map((item, index) => (
            <div className={styles.item} key={index}>
              <div className={styles.productName}>{item.product_name}</div>
              <div className={styles.content}>{item.content}</div>
              <div className={styles.bottomRow}>
                <div className={styles.left}>
                  <div>{item.name}</div>
                  <div>{moment(item.review_date).format("YYYY-MM-DD")}</div>
                </div>
                <div className={styles.right}>
                  <StarRating initialValue={item.star} width={93} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
